import React from 'react'
import { Route, Routes } from 'react-router'

import { PublicTopPage } from '~/pages/PublicTopPage'

export const Unauthenticated = () => (
  <Routes>
    <Route element={<PublicTopPage />} path="*" />
  </Routes>
)
